import { DATE_FORMAT, DATE_TIME_FORMAT } from 'CORE/utils/date'
import labels from 'CORE/utils/labels'
import FileSaver from 'file-saver'
import _ from 'lodash'
import moment from 'moment'

export default {
    methods: {
        exportTableData() {
            const pvExportValue = (v, k) => {
                const pt = this.$store.getters.propertyTypeByKey(k)
                const ptType = _.get(pt, 'type')
                const value = _.get(v, 'value.value')

                switch (ptType) {
                    case 'NUMERIC':
                        return _.get(v, 'value.value.number', '')
                    case 'DATE_TIME':
                        return moment(value, 'X').format(DATE_TIME_FORMAT)
                    case 'DATE':
                        return moment(value, 'X').format(DATE_FORMAT)
                    case 'LONGTEXT':
                        if (_.isString(value)) {
                            return value.replace(/"/g, '""')
                        }
                        return ''
                    case 'LINK_PERSON_RESOURCE':
                    case 'LINK_THING_RESOURCE':
                    case 'LINK_PLACE_RESOURCE':
                        return _.map(value, rid => {
                            return labels.resource(this.$store.getters.resourceById(rid))
                        }).join(', ')
                    case 'LINK_USER':
                        return _.map(value, uid => {
                            return _.get(this.$store.getters.userById(uid), 'username')
                        }).join(', ')
                    case 'BOOLEAN':
                        return value ? 'Ano' : 'Ne'
                    case 'ENTITY_STATE':
                        const allStates = _.get(this.$store.getters.currentUser, 'company.settings.entity-states.states', {})
                        return _.get(_.find(allStates, { id: value }), 'label', '-- unknown state --')
                    case 'LINK':
                        const linkType = _.get(pt, 'settings.link.entity')
                        return _.map(value, id => {
                            if (linkType === 'TASK') {
                                return labels.task(this.$store.getters.taskById(id))
                            } else if (linkType === 'PROJECT') {
                                return labels.project(this.$store.getters.getProjectById(id))
                            } else {
                                return '-- unknown link type --'
                            }
                        }).join(', ')
                    case 'STATIC_STRING':
                    default:
                        if (_.isObject(value) && _.has(value, 'unit')) {
                            const num = _.get(value, 'number', _.get(value, 'value'))
                            if (num !== undefined) {
                                return `${num} ${value.unit}`
                            }
                        }
                        return value
                }
            }
            const data = _.map(this.exportEntities, p => {
                const pv = _.get(p, 'propertyValues')
                return _.map(this.exportKeys, k => {
                    if (_.get(pv, k, false)) {
                        return pvExportValue(_.get(pv, k), k)
                    }
                    return null
                })
            })

            const header = _.map(this.exportKeys, k => {
                return _.get(this.$store.getters.propertyTypeByKey(k), 'name', k)
            })

            const blobString = _.map([header, ...data], r => {
                return _.map(r, c => (c === null || c === undefined) ? '' : `"${c}"`).join(',')
            }).join('\n')

            let filename = 'asd-export'
            try {
                filename = this.$route.fullPath.replace(/[^a-z0-9]+/g, '-').replace(/^-/, '')
            } catch (e) {
                console.warn(e)
            }

            const blob = new Blob([blobString], { type: 'text/csv;charset=utf-8' })
            FileSaver.saveAs(blob, `${filename}.csv`)
        },
    },
}
